import React from 'react';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import { Typography } from '../typography';
import clsx from 'clsx';

interface Props {
	icon?: string;
	message?: string;
	classNameIcon?: string;
}

export const EmptyGeneral: React.FC<Props> = ({
	icon,
	message,
	classNameIcon,
}) => {
	return (
		<div className="flex flex-col items-center">
			<Icon
				src={icon ?? Icons.emptyClipNote}
				width={156}
				height={126}
				className={clsx('w-[175px] h-[140px]', classNameIcon)}
			/>
			<Typography
				type="regular-18"
				className="font-normal text-center px-8 md:px-0"
			>
				{message || 'There is no data available to display yet.'}
			</Typography>
		</div>
	);
};
